import React from "react";
import "./PrivacyPolicy.scss";
import {MDBBox, MDBTypography} from "mdbreact";
import BottomNav from "../../component/BottomNav/BottomNav";
import TopNavSubpage from "../../component/TopNav/TopNavSubpage";
import PrivacyPolicyContent from "../../component/PrivacyPolicyContent";

class PrivacyPolicy extends React.Component {
	render() {
		return (
			<div>
				<TopNavSubpage heading={"Privacy Policy"} notify={false} border={true} wallet={false}/>
				<div className={"py-2 px-4"}>
					<PrivacyPolicyContent/>
					<br/><br/>
					<br/><br/>
				</div>

				{/*<MDBBox className="bottom-navbar">*/}
				{/*	<BottomNav/>*/}
				{/*</MDBBox>*/}
			</div>

		);
	}
}

export default PrivacyPolicy;